import React, { useState } from 'react';
import api from '../../services/api';

/**
 * Composant réutilisable : checkbox tâche avec modal de preuve obligatoire
 * avant de marquer comme terminée.
 */
export default function TaskToggleWithPreuve({ task, onToggle, onToggleWithPreuve, style = {} }) {
  const [showModal, setShowModal] = useState(false);
  const [justifText, setJustifText] = useState('');
  const [preuveFile, setPreuveFile] = useState(null);

  const handleClick = () => {
    if (task.done) {
      // Décocher : pas de preuve nécessaire
      onToggle(task.id);
    } else {
      setJustifText('');
      setPreuveFile(null);
      setShowModal(true);
    }
  };

  const handleValider = async () => {
    if (!justifText.trim()) { alert('Veuillez décrire ce que vous avez réalisé.'); return; }
    if (!preuveFile) { alert('Veuillez joindre un document de preuve avant de valider.'); return; }
    try {
      console.log('📤 Upload du document de preuve...', {
        taskId: task.id,
        fileName: preuveFile.name,
        fileSize: preuveFile.size
      });

      // 1. Upload du document de preuve
      const uploadResponse = await api.tasks.uploadProof(task.id, preuveFile);
      console.log('✅ Upload réussi:', uploadResponse);
      
      // 2. Marquer la tâche comme terminée
      console.log('📝 Marquage de la tâche comme terminée...');
      await api.tasks.toggle(task.id);
      console.log('✅ Tâche marquée comme terminée');
      
      // Appeler le callback parent pour rafraîchir l'UI
      if (onToggleWithPreuve) {
        onToggleWithPreuve(task.id);
      } else if (onToggle) {
        onToggle(task.id);
      }
      
      alert('✅ Tâche validée avec succès !');
    } catch (err) {
      console.error('❌ Erreur lors de la validation:', err);
      alert('Erreur lors de l\'envoi du document : ' + (err.message || 'Erreur inconnue'));
      return;
    }
    setShowModal(false);
  };

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          width: 18, height: 18, borderRadius: 4, cursor: 'pointer', flexShrink: 0,
          border: task.done ? 'none' : '1.5px solid #445',
          background: task.done ? '#4caf50' : 'transparent',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 10, color: 'white',
          ...style
        }}
      >
        {task.done ? '✓' : ''}
      </div>

      {showModal && (
        <div
          onClick={e => e.target === e.currentTarget && setShowModal(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div style={{ background: '#0d1825', border: '1px solid rgba(255,255,255,.1)', borderRadius: 12, padding: 24, width: 480, maxWidth: '92%' }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#fff', marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
              Valider la tâche
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', color: '#667', fontSize: 18, cursor: 'pointer' }}>✕</button>
            </div>

            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '.7px', textTransform: 'uppercase', color: '#8a9bb0', marginBottom: 5 }}>Tâche</div>
              <div style={{ padding: '9px 11px', background: 'rgba(255,255,255,.03)', borderRadius: 7, fontSize: 12, color: '#aaa' }}>{task.titre || task.text}</div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '.7px', textTransform: 'uppercase', color: '#8a9bb0', marginBottom: 5 }}>Ce que j'ai réalisé *</div>
              <textarea
                rows={3}
                placeholder="Décrivez concrètement ce que vous avez accompli..."
                value={justifText}
                onChange={e => setJustifText(e.target.value)}
                style={{ background: 'rgba(255,255,255,.05)', border: '1.5px solid rgba(255,255,255,.1)', borderRadius: 7, padding: '9px 11px', color: '#fff', fontSize: 12, outline: 'none', width: '100%', resize: 'vertical' }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '.7px', textTransform: 'uppercase', color: '#8a9bb0', marginBottom: 5 }}>Document de preuve *</div>
              <div
                onClick={() => document.getElementById(`preuve-dept-${task.id}`).click()}
                style={{ marginTop: 4, border: `2px dashed ${preuveFile ? 'rgba(67,160,71,.5)' : 'rgba(255,255,255,.15)'}`, borderRadius: 8, padding: '14px 12px', textAlign: 'center', cursor: 'pointer', background: preuveFile ? 'rgba(67,160,71,.06)' : 'rgba(255,255,255,.02)' }}
              >
                <input id={`preuve-dept-${task.id}`} type="file" style={{ display: 'none' }}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                  onChange={ev => setPreuveFile(ev.target.files[0] || null)} />
                {preuveFile
                  ? <div style={{ fontSize: 12, color: '#66bb6a', fontWeight: 600 }}>Fichier joint : {preuveFile.name}</div>
                  : <div style={{ fontSize: 11, color: '#667' }}>Cliquer pour joindre un fichier (PDF, Word, Excel, Image)</div>}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowModal(false)}
                style={{ background: 'transparent', border: '1.5px solid rgba(255,255,255,.1)', borderRadius: 7, padding: '8px 16px', color: '#888', fontSize: 12, cursor: 'pointer' }}>
                Annuler
              </button>
              <button onClick={handleValider}
                style={{ background: 'linear-gradient(135deg,#C9A84C,#8a6028)', border: 'none', borderRadius: 7, padding: '8px 16px', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                Valider la tâche
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
